import {ChangesSnapshot} from 'modules/hierarchy/models';
import {SubjectInfo} from '../../services/subjects-service/models';

export class HomepageOutsideChangeEvent {
	hierarchy: ChangesSnapshot = {};
	subject?: SubjectInfo;
	pieChartsChanged?: boolean;
}
